
import {
  AiOutlineInteraction,
  // AiOutlineExport,
  AiOutlineHome,
  AiOutlineUser,
  AiOutlineMail,
  AiOutlineSetting,
  AiOutlineCheckCircle,
  AiOutlineTeam,
  AiOutlineProfile,
  AiOutlineStock,
} from "react-icons/ai";

const getLocalStorageItem = (key, defaultValue = null) => {
  try {
    const item = localStorage.getItem(key);

    if (item === null) {
      // Item not found in localStorage
      return defaultValue;
    }

    try {
      return JSON.parse(item);
    } catch (parseError) {
      if (item === "true") return true;
      if (item === "false") return false;
      // Attempt to convert numeric strings to numbers
      if (!isNaN(Number(item)) && !isNaN(parseFloat(item))) return Number(item);

      return item;
    }
  } catch (error) {
    console.error(`Error accessing localStorage for key "${key}":`, error);
    return defaultValue;
  }
};

export const CURRENT_USER = getLocalStorageItem("currentUser");

export function getReadableDate(receivedDate) {
  return (
    new Date(receivedDate).getDate() +
    "/" +
    (new Date(receivedDate).getMonth() + 1) +
    "/" +
    new Date(receivedDate).getFullYear()
  );
}

export function getReadableDateAndMonth(receivedDate) {
  return (
    new Date(receivedDate).getDate() +
    "/" +
    (new Date(receivedDate).getMonth() + 1)
  );
}

export function getReadableDateYYYYMMDD(receivedDate) {
  return (
    new Date(receivedDate).getFullYear() +
    "-" +
    (new Date(receivedDate).getMonth() + 1 < 10
      ? "0" + (new Date(receivedDate).getMonth() + 1)
      : new Date(receivedDate).getMonth() + 1) +
    "-" +
    new Date(receivedDate).getDate()
  );
}

// export function getReadableDateDDMMYYYY(receivedDate) {
//   return (
//     new Date(receivedDate).getDate() +
//     "-" +
//     (new Date(receivedDate).getMonth() + 1 < 10
//       ? "0" + (new Date(receivedDate).getMonth() + 1)
//       : new Date(receivedDate).getMonth() + 1) +
//     "-" +
//     new Date(receivedDate).getFullYear()
//   );
// }

export function getReadableDateDDMMYYYY(receivedDate) {
  if (!receivedDate) return "";

  const date = new Date(receivedDate);

  const day = date.getDate().toString().padStart(2, "0");

  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  const month = months[date.getMonth()];
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
}

export function getAllDaysInMonth(year, month) {
  const date = new Date(year, month, 1);

  const dates = [];

  while (date.getMonth() === month) {
    dates.push("" + new Date(date).getDate());
    date.setDate(date.getDate() + 1);
  }

  return dates;
}

export function getReadableTime(receivedDate) {
  return new Date(receivedDate).toLocaleTimeString([], { timeStyle: "medium" });
}

export function getReadableTimeOnlyHourMinutes(receivedDate) {
  return new Date(receivedDate).toLocaleTimeString([], {
    timeStyle: "short",
  });
}

export function getMonthNameFromDate(receivedDate) {
  var monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  return monthNames[new Date(receivedDate).getMonth()];
}

export function consolePrint(msg) {
  console.log(msg);
}

// /////////////////////////////////////

// import ic_purchase from "../img/purchase.svg";
// import ic_inventory from "../img/inventory.svg";
// import ic_invoice from "../img/invoice.svg";
// import ic_marketing from "../img/marketing.svg";
// import ic_project from "../img/project.svg";


const menu_list = [
  // faizan

  {
    menu_id: "View_jobs",
    url_path: "/jobs",
    image: (
      <AiOutlineHome className="w-6 h-6 mb-1 text-[#787878] group-hover:text-white  transition-all duration-300 group-hover:animate-bounce hover:scale-110" />
    ),
  },
  
];

const module_list = [
  {
    module_id: "PURCHASE",
    image: <AiOutlineHome className="w-6 h-6 mb-1 text-[#787878] group-hover:text-white  transition-all duration-300 group-hover:animate-bounce hover:scale-110" />,
  },
  {
    module_id: "INVENTORY",
    image: <AiOutlineHome className="w-6 h-6 mb-1 text-[#787878] group-hover:text-white  transition-all duration-300 group-hover:animate-bounce hover:scale-110" />,
  },
  {
    module_id: "SALES",
    image: <AiOutlineHome className="w-6 h-6 mb-1 text-[#787878] group-hover:text-white  transition-all duration-300 group-hover:animate-bounce hover:scale-110" />,
  },
  {
    module_id: "MARKETING",
    image: <AiOutlineHome className="w-6 h-6 mb-1 text-[#787878] group-hover:text-white  transition-all duration-300 group-hover:animate-bounce hover:scale-110" />,
  },
  
];

const sub_module_list = [
  {
    sub_module_id: "sales-orders",
    image: <AiOutlineHome className="w-6 h-6 mb-1 text-[#787878] group-hover:text-white  transition-all duration-300 group-hover:animate-bounce hover:scale-110" />,
  },
  
];


export function getAllModuleImages() {
  return module_list;
}



